// Material
import { List } from '@mui/material'
import { styled } from '@mui/material/styles'
// Common
import { ProfileActionItem } from '$common/profile-action-item'
import { ChatIcon } from '$common/icons'
// Localization
import { t } from '$i18n'
import { openRoom } from '$logic/opened-room'
import { usePvByUserId } from '$logic/pv/react-hook'
import { getPvByUserId } from '$logic/pv'
import { SharedMediaProfileActionItem } from '$common/shared-media-profile-action-item'

const StyledList = styled(List)`
  padding-top: 0;
  padding-bottom: 0;
  background-color: white;
  margin-top: 10px;
`

interface Prop {
  userId: string
}

export function UserProfileActions({ userId }: Prop) {
  const { pv } = usePvByUserId(userId)
  const onSendMessage = async () => {
    const { roomId } = pv || (await getPvByUserId(userId))
    openRoom(roomId)
  }

  return (
    <StyledList>
      <ProfileActionItem Icon={<ChatIcon />} onClick={onSendMessage}>
        {t('profile.user.sendMessage')}
      </ProfileActionItem>
      {pv && <SharedMediaProfileActionItem roomId={pv.roomId} />}
    </StyledList>
  )
}
